var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinitiHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29447",
    "data-name": "Group 29447",
    transform: "translate(-422 -662.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(422 662.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29221",
    "data-name": "Group 29221",
    transform: "translate(632.399 11061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50576",
    "data-name": "Path 50576",
    d: "M22.2,15.389C21.77,11.7,17.11,9,11.121,9,5.2,9,.547,11.656.05,15.317A4.431,4.431,0,0,0,0,15.942a3.848,3.848,0,0,0,.621,2.226c2,3.038,6.764,4.047,6.969,4.094l.751.176,2.78-6.487,2.78,6.487.751-.175c.2-.048,4.966-1.056,6.969-4.094a3.849,3.849,0,0,0,.621-2.226A4.259,4.259,0,0,0,22.2,15.389Zm-1.35,2.269c-1.822,2.765-6.483,3.853-6.483,3.853L11.121,14.1,7.877,21.511s-4.66-1.088-6.483-3.853a2.958,2.958,0,0,1-.468-1.708,3.56,3.56,0,0,1,.042-.509c.425-3.13,4.727-5.515,10.152-5.515,5.468,0,9.792,2.423,10.158,5.59a3.408,3.408,0,0,1,.036.434A2.958,2.958,0,0,1,20.847,17.658Z",
    transform: "translate(-195 -10398)",
    fill: "#9fa8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50577",
    "data-name": "Path 50577",
    d: "M23.487,27.414,20.244,20,17,27.414l.463.927,2.78-6.487,2.78,6.487Z",
    transform: "translate(-204.122 -10403.902)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50578",
    "data-name": "Path 50578",
    d: "M22.352,16.59C21.986,13.423,17.662,11,12.194,11c-5.425,0-9.727,2.384-10.152,5.515A3.56,3.56,0,0,0,2,17.024a2.958,2.958,0,0,0,.468,1.708C4.29,21.5,8.95,22.584,8.95,22.584l3.244-7.414,3.244,7.414S20.1,21.5,21.92,18.731a2.958,2.958,0,0,0,.468-1.708A3.408,3.408,0,0,0,22.352,16.59Zm-5.061,3.678-5.1-6.024L7.1,20.267s-4.17-1.178-4.17-3.244a2.818,2.818,0,0,1,.042-.455c.008-.047.017-.095.027-.142a3.009,3.009,0,0,1,.1-.349c.012-.034.02-.068.032-.1.882-2.309,4.612-4.048,9.068-4.048,4.081,0,7.547,1.46,8.78,3.479q.079.131.145.265c.026.052.051.1.074.158.041.094.079.189.111.284.023.068.04.137.057.206s.043.158.057.237a2.867,2.867,0,0,1,.043.468C21.461,19.089,17.291,20.267,17.291,20.267Z",
    transform: "translate(-196.073 -10399.072)",
    fill: "#c5cae9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinitiHighlighted);
export default __webpack_public_path__ + "static/media/infinitiHighlighted.30df11609e21bca912030dd5b636684c.svg";
export { ForwardRef as ReactComponent };